import { useMutation } from "@tanstack/react-query";
import { SignupAttributes, User } from "@api/v1/model";
import { signup } from "@api/v1/methods";

export const useSignup = () =>
  useMutation<User, AxiosApiError, SignupAttributes>({ mutationFn: signup });
